/**
 * Decides whether a text element that just exited edit mode should be auto-removed
 * because it is empty.
 *
 * Clearing all of a text element's content normally deletes the element. But a
 * personalizable text layer (personalization plugin enabled and the layer's
 * personalization toggle switched on, i.e. not `personalizationLocked`) must survive
 * being emptied: the empty box is a valid placeholder that the buyer fills in on the
 * product page, and removing it would silently drop the whole personalization layer.
 */
export default function isEmptyTextEligibleForRemoval(
  text: string | undefined,
  isDragging: boolean,
  isPersonalizableLayer: boolean,
): boolean {
  // Don't remove while the user is dragging the element.
  if (isDragging) {
    return false;
  }

  // Keep personalizable layers even when their text is cleared.
  if (isPersonalizableLayer) {
    return false;
  }

  return !text || !text.trim().length;
}
